var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextFormatClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "-7 -7 30 30",
    fill: "none",
    stroke: "#929497",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 10.333c0-.598.059-.833-.637-2.333-.696-1.5-4.03-7-4.03-7s-.813 1.423-1.719 3M3.664 6.232C3.198 7.04 2.814 7.705 2.638 8 2 9.071 2 9.735 2 10.333a4.667 4.667 0 008.45 2.734M1.707 4L12 14.293",
    strokeLinecap: "round"
  })));
}

export default SvgTextFormatClear;